import React from "react";
import "./style/card.css";

const Card = (props) => {
  const { pokemon } = props;

  return (
    <div className="card">
      <div className="cardImg">
        <img src={pokemon.sprites.front_default} alt=""></img>
      </div>

      <h3 className="cardName">{pokemon.name}</h3>

      <div className="cardTypes">
        <div>タイプ</div>
        {pokemon.types.map((type) => {
          return (
            <div key={type.type.name}>
              <span className="typeName">{type.type.name}</span>
            </div>
          );
        })}
      </div>
      <div className="cardInfo">
        <div className="cardData">
          <p className="title">重さ：{pokemon.weight}</p>
        </div>
        <div className="cardData">
          <p className="title">高さ：{pokemon.height}</p>
        </div>
        <div className="cardData">
          <p className="title">特性：{pokemon.abilities[0].ability.name}</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
